import apiCall from 'apps/catalog/apiCalls/fund-products';
import { DynamicFilterForm } from 'common/dynamic-filter-form';
import { DetailPage, EditPage, ListPage } from 'common/ui/admin-CRUD/page';
import { columnsGenerator } from './config';
import ItemDetail from './detail';
import ItemForm from './edit-form';

export const InvestmentProductListPage = () => (
  <ListPage
    title="All Fund Products"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={DynamicFilterForm}
  />
);

export const InvestmentProductEditPage = props => (
  <EditPage
    title="Edit Fund Product"
    apiCall={apiCall}
    listUrl={`/catalog/products/funds`}
    detailUrl={`/catalog/products/funds/:id`}
    ItemForm={ItemForm}
    resourceName="data"
    {...props}
  />
);

export const InvestmentProductDetailPage = props => (
  <DetailPage
    title="Fund Product"
    apiCall={apiCall}
    listUrl={`/catalog/products/funds`}
    ItemDetail={ItemDetail}
    resourceName="data"
    options={{ editEnabled: true }}
    {...props}
  />
);
